import React from 'react';
import { Icon } from 'antd';
import { ReactComponent as OwnerIcon } from '../../../resource/OwnerIcon.svg';
import { ReactComponent as WorkerIcon } from '../../../resource/WorkerIcon.svg';
import { ReactComponent as OtherIcon } from '../../../resource/OtherIcon.svg';

const icons = {
  Owner: OwnerIcon,
  Worker: WorkerIcon,
  Other: OtherIcon
}

const ApplicantIcons = ({ contactType, className }) => {
  return <Icon component={icons[contactType]} className={className} />
};

export default ApplicantIcons;
